import Swal from 'sweetalert2';

export default function openMejorPrecioModal(barra: any, axios: any, apiRoute: any) {
    const toNum = (v: any) => {
        if (v === null || v === undefined) {
            return 0;
        }
        // soporta "1.234,56" y "1234.56"
        const s = String(v).trim().replace(/\./g, '').replace(',', '.');
        const n = Number(s);
        return Number.isFinite(n) ? n : 0;
    };

    const money2 = (n: any) => {
        const x = Number(n || 0);
        return x.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const money4 = (n: any) => {
        const x = Number(n || 0);
        return x.toLocaleString('es-VE', { minimumFractionDigits: 4, maximumFractionDigits: 4 });
    };

    const chip = (txt: string) => `<span class="chip">${txt}</span>`;

    Swal.fire({
        allowOutsideClick: false,
        focusConfirm: false,
        didOpen: () => {
            Swal.showLoading();
            const token = localStorage.getItem('authToken');

            axios.get(`${apiRoute}/cat/getBestSeller`, {
                headers: { 'Authorization': `Bearer ${token}` },
                params: { barra }
            })
                .then((response: any) => {
                    const rows = Array.isArray(response?.data) ? response.data : [];

                    // Normalizar y ordenar por NETO (Bs) asc
                    const normalized = rows.map((r: any) => {
                        const netoBs = (r.NETO);
                        const netoUsd = (r.NETO_EXT);
                        return {
                            ...r,
                            __netoBs: netoBs,
                            __netoUsd: netoUsd
                        };
                    }).sort((a: any, b: any) => a.__netoBs - b.__netoBs);

                    const best = normalized[0] || null;
                    const bestBs = best ? best.__netoBs : 0;
                    const bestUsd = best ? best.__netoUsd : 0;

                    const headerHtml = `
                        <div class="hdr">
                            <div class="hdr-left">
                                <div class="ttl">Comparativo mejor precio de venta</div>
                                <div class="sub">Barra: <b>${barra ?? ''}</b></div>
                                <div class="meta">
                                    ${chip(`Registros: ${normalized.length}`)}
                                    ${best ? chip(`Mejor: Bs ${money2(bestBs)} / $ ${money2(bestUsd)}`) : chip('Sin resultados')}
                                </div>
                            </div>
                        </div>
                    `;

                    let html = `
                        <style>
                            .swal-wide { width: 1150px !important; }
                            .wrap { font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#0f172a; }
                            .hdr { display:flex; align-items:center; justify-content:center; gap:12px; margin-bottom:12px; }
                            .ttl { font-size:16px; font-weight:800; }
                            .sub { font-size:13px; color:#334155; margin-top:2px; }
                            .meta { margin-top:8px; display:flex; flex-wrap:wrap; gap:6px; justify-content:center; }
                            .chip { display:inline-block; padding:4px 8px; border-radius:999px; font-size:12px; background:#f1f5f9; border:1px solid #e2e8f0; color:#0f172a; }

                            .tableWrap { border:1px solid #e2e8f0; border-radius:12px; overflow:hidden; }
                            .scroll { max-height: 62vh; overflow:auto; }

                            table { width:100%; border-collapse:separate; border-spacing:0; }
                            thead th {
                                position: sticky; top: 0;
                                background:#0b63a6; color:#fff;
                                font-size:12px; text-align:left;
                                padding:10px 10px;
                                border-bottom:1px solid rgba(255,255,255,.2);
                                white-space:nowrap;
                                z-index:2;
                            }
                            tbody td {
                                font-size:12px; padding:10px 10px;
                                border-bottom:1px solid #eef2f7;
                                vertical-align:top;
                                white-space:nowrap;
                            }
                            tbody tr:nth-child(even) td { background:#f8fafc; }

                            .num { text-align:right; }
                            .center { text-align:center; }
                            .muted { color:#64748b; font-size:11px; margin-top:2px; }
                            .desc { max-width: 340px; white-space:normal; line-height:1.25; }
                            .prov { max-width: 220px; white-space:normal; line-height:1.25; }

                            .moneyCell { line-height:1.15; }
                            .moneyTop { font-weight:700; }
                            .moneyBottom { color:#64748b; font-size:11px; margin-top:3px; }

                            tr.row-best td { background:#ecfdf5 !important; }
                            .badge { display:inline-block; padding:2px 8px; border-radius:999px; font-size:11px; border:1px solid #e2e8f0; background:#fff; }
                            .bmin { border-color:#22c55e; color:#166534; background:#ecfdf5; }
                        </style>

                        <div class="wrap">
                            ${headerHtml}
                            <div class="tableWrap">
                                <div class="scroll">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style="width:46px">#</th>
                                                <th>Proveedor</th>
                                                <th style="width:120px">Cod. prov</th>
                                                <th style="width:120px">Cod. prod</th>
                                                <th style="width:360px">Descripción</th>
                                                <th class="center" style="width:110px">Cantidad</th>
                                                <th class="num" style="width:160px">Neto</th>
                                                <th style="width:90px">Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                    `;

                    normalized.forEach((item: any, idx: number) => {
                        const isBest = idx === 0 && normalized.length > 0;

                        const proveedor = item.DESCRIPCION ?? '';
                        const codprov = item.CODPROV ?? '';
                        const codprod = item.CODPROD ?? '';
                        const desprod = item.DESPROD ?? '';
                        const cantidad = item.CANTIDAD ?? '';

                        const netoBs = item.NETO ?? '';
                        const netoUsd = item.NETO_EXT ?? '';

                        html += `
                            <tr class="${isBest ? 'row-best' : ''}">
                                <td>${idx + 1}</td>

                                <td class="prov">${proveedor}</td>
                                <td>${codprov}</td>
                                <td>${codprod}</td>
                                <td class="desc">${desprod}</td>

                                <td class="center">${cantidad}</td>

                                <td class="num moneyCell">
                                    <div class="moneyTop">Bs ${money2(netoBs)}</div>
                                    <div class="moneyBottom">$ ${money2(netoUsd)}</div>
                                </td>

                                <td>
                                    ${isBest ? `<span class="badge bmin">MEJOR</span>` : `<span class="muted">—</span>`}
                                </td>
                            </tr>
                        `;
                    });

                    if (normalized.length === 0) {
                        html += `
                            <tr>
                                <td colspan="8" class="muted" style="padding:14px;">
                                    No hay resultados para esta barra.
                                </td>
                            </tr>
                        `;
                    }

                    html += `
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    `;

                    Swal.fire({
                        title: '',
                        html,
                        showCloseButton: true,
                        showConfirmButton: false,
                        focusConfirm: false,
                        customClass: { popup: 'swal2-popup swal2-modal swal2-show swal-wide' }
                    });
                })
                .catch((error: any) => {
                    const errorMessage = error.response ? (error.response.data?.message ?? JSON.stringify(error.response.data)) : 'La petición falló.';
                    Swal.fire({
                        focusConfirm: false,
                        title: 'Error',
                        text: errorMessage,
                        icon: 'error',
                        showConfirmButton: true
                    });
                });
        }
    });
}
